// oxlint-disable-next-line typescript-eslint/no-explicit-any
export const addUtils = (obj: any) => {
  obj.$ = function (selector: string): Element | null {
    return document.querySelector(selector);
  };

  obj.$$ = function (selector: string): Array<Element> {
    return Array.from(document.querySelectorAll(selector));
  };
};
